import { Component, inject } from '@angular/core';
import { TranslatePipe } from '@ngx-translate/core';
import { Observable } from 'rxjs';
import { ActivatedRoute, Router } from '@angular/router';
import { RouteEntity } from '@core/router/route.entity';
import { B2bProgramsState } from '../../shared/state/b2b-programs-state';
import { RxEffects } from '@rx-angular/state/effects';
import { Service } from '@api/models/B2bService/Contract/service';
import { HeadlineWrapperModule } from '@ui/layout/headline-wrapper/headline-wrapper.module';
import { HeadlineModule } from '@ui/layout/headline/headline.module';
import { AddB2BProgramRequest } from '@api/models/B2bService/Contract/add-b-2-b-program-request';
import { Tariffs } from '@api/models/B2bService/Contract/tariffs';
import { StartWithUnit } from '@core/state/operators/start-with-unit';
import { AbstractListModel } from '@libs/factory/abstract-list/abstract-list.model';
import { AsyncPipe } from '@angular/common';
import { PushService } from '@core/push/push.service';
import { PushCodeModel } from '@core/push/push-code.model';
import { b2bProgramRateList } from '../../shared/models/b2b-program-rate.model';
import { b2bProgramUnitList } from '../../shared/models/b2b-program-unit.model';
import { B2BPartnerListResponse } from '@api/models/B2bService/Contract/B2bPartner/b-2-b-partner-list-response';
import { B2bProgramType } from '../../shared/models/b2b-program-type';
import { RoutingQueryParamsName } from '@core/router/routing.params';
import {
    ProgramNumberOfTripsFormComponent,
} from './program-form/program-number-of-trips-form/program-number-of-trips-form.component';
import { getLoadingProp } from '@core/state/operators/start-with-loading';
import {
    ProgramSingleProductFormComponent,
} from './program-form/program-single-product-form/program-single-product-form.component';


@Component({
    selector: 'b2b-page-program-add',
    templateUrl: './program-add.component.html',
    styleUrls: ['./program-add.component.scss'],
    providers: [RxEffects],
    imports: [
        HeadlineWrapperModule,
        HeadlineModule,
        AsyncPipe,
        ProgramNumberOfTripsFormComponent,
        ProgramSingleProductFormComponent,
        TranslatePipe,
    ],
})
export class ProgramAddComponent {
    readonly #b2bProgramsState: B2bProgramsState = inject(B2bProgramsState);
    readonly #router: Router = inject(Router);
    readonly #route: ActivatedRoute = inject(ActivatedRoute);
    readonly #push: PushService = inject(PushService);
    readonly #effects: RxEffects = inject(RxEffects);

    public readonly services$: Observable<Service[]> = this.#b2bProgramsState.services$;
    public readonly tickets$: Observable<Tariffs[]> = this.#b2bProgramsState.tickets$;
    public readonly partners$: Observable<B2BPartnerListResponse[]> = this.#b2bProgramsState.partners$;

    public readonly pending$: Observable<boolean> = this.#b2bProgramsState.loading$.pipe(
        getLoadingProp(StartWithUnit.RequestAddB2BProgram),
    );

    public readonly selectedB2bProgramType: B2bProgramType = Number(
        this.#route.snapshot.queryParamMap.get(RoutingQueryParamsName.B2bProgramType),
    );

    public readonly units: AbstractListModel[] = b2bProgramUnitList;
    public readonly rateTypes: AbstractListModel[] = b2bProgramRateList;
    public readonly b2bProgramType: typeof B2bProgramType = B2bProgramType;

    constructor() {
        this.#b2bProgramsState.requestServices();
    }

    public handlerChangeService(srvId: number): void {
        this.#b2bProgramsState.requestTickets(srvId);
    }

    public handlerAddProgram(body: AddB2BProgramRequest): void {
        this.#effects.register(this.#b2bProgramsState.createProgram(body), () => {
            this.#router.navigate([RouteEntity.Root, RouteEntity.Programs]).then(() => this.#push.success(PushCodeModel.SuccessAdd));
        });
    }
}
